export default {
      id: "social-instagram-usage",
      viewBox: "0 0 22 22",
      url: __webpack_public_path__ + "sprite.svg#social-instagram",
      toString: function () {
        return this.url;
      }
    }


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/social-instagram.svg
// module id = 137
// module chunks = 241 242 243